// extracted by mini-css-extract-plugin
module.exports = {"filters":"vehicle_filters__17aps","table":"vehicle_table__1C9rf"};